<template>
  <div class="box-filter">
    <el-form :model="ruleForm" ref="ruleForm" @submit.prevent v-on:submit.prevent>
      <el-row :gutter="20">
        <el-col :sm="19" :md="19">
          <div class="textfilter">
            <el-input size="large" v-model="ruleForm.searchInput" class="input-with-select">
              <el-button slot="append" icon="el-icon-search" native-type="submit" @click.prevent="searchTable" />
            </el-input>
            <el-tooltip v-if="ruleForm.searchInput" effect="dark" content="Limpar Filtro" placement="top">
              <el-button @click="clearSearch" type="text" class="clear-filter">
                <XIcon size="1.5x" />
              </el-button>
            </el-tooltip>
          </div>
        </el-col>
        <el-col :sm="5" :md="5">
          <el-button type="default" size="large" @click="viewFilter = !viewFilter">
            Filtros por:<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
        </el-col>
      </el-row>
      <div v-show="viewFilter" class="viewFilter">
        <el-row :gutter="20">
         <el-col :span="8">
           <el-form-item prop="status" label="Status">
             <el-select v-model="ruleForm.status" clearable>
               <el-option label="Ativo" value="active" />
               <el-option label="Inativo" value="inactive" />
             </el-select>
           </el-form-item>
         </el-col>
         <el-col :span="8">
           <el-form-item prop="serial_number" label="Nº Serial">
             <el-input size="large" v-model="ruleForm.serial_number" required />
           </el-form-item>
         </el-col>
         <el-col :span="8">
           <el-form-item prop="marketplace_id" label="Marketplace">
             <SelectSearchMarketplace :disabled="$can('2|4|5')" :model="ruleForm.marketplace_id" :isEdit="false" @handleValue="(x) => {$set(ruleForm, 'marketplace_id', x)}" />
           </el-form-item>
         </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="agent_id" label="Representante">
              <SelectSearchRepresentante :disabled="$can('2|4|5')" :model="ruleForm.agent_id" :isEdit="false" @handleValue="(x) => {$set(ruleForm, 'agent_id', x)}" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="equipment_model_id" label="Modelo Equipamento">
              <SelectSearchModeloEquipamento :model="ruleForm.equipment_model_id" :isEdit="false" @handleValue="(x) => {$set(ruleForm, 'equipment_model_id', x)}" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
          <el-col :xs="24" :span="15">
            <el-button  native-type="submit" @click.prevent='searchTable' type="primary" size="large" style="float: right">
              Filtrar
            </el-button>
            <el-button v-if="statusClearFilter" @click='clearSearch' type="default" size="large" style="float: right; margin-right: 20px">
              Limpar Filtros
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
import {XIcon} from "vue-feather-icons";
import SelectSearchMarketplace from "@/app/components/Marketplace/SelectSearchMarketplace";
import SelectSearchRepresentante from "@/app/components/Representante/SelectSearchRepresentante";
import SelectSearchModeloEquipamento from "@/app/components/ModeloEquipamento/SelectSearchModeloEquipamento";
import {mapGetters} from "vuex";

export default {
  name: "FilterBox",
  components: {
    XIcon,
    SelectSearchMarketplace,
    SelectSearchRepresentante,
    SelectSearchModeloEquipamento,
  },
  data () {
    return {
      loadingPage: true,
      ruleForm: {
        searchInput: '',
        serial_number: null,
        status: null,
        marketplace_id: null,
        agent_id: null,
        equipment_model_id: null,
      },
      viewFilter: false,
    }
  },
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    type: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters('Auth', ['currentUser']),
    statusClearFilter: function () {
      if (this.ruleForm.searchInput || this.ruleForm.serial_number || this.ruleForm.status || this.ruleForm.marketplace_id || this.ruleForm.agent_id || this.ruleForm.equipment_model_id) {
        return true
      }
      return false
    }
  },
  methods: {
    clearSearch () {
      this.viewFilter = false
      this.ruleForm = {
        searchInput: '',
        serial_number: null,
        status: null,
        marketplace_id: null,
        agent_id: null,
        equipment_model_id: null,
      }
      this.$emit('filter', `?page=${this.currentPage}`)
    },
    searchTable () {
      let query = `?page=${this.currentPage}`

      if (this.ruleForm.searchInput) {
        query = `${query}&name=${this.ruleForm.searchInput}`
      }
      if (this.ruleForm.serial_number) {
        query = `${query}&serial_number=${this.ruleForm.serial_number}`
      }
      if (this.ruleForm.status) {
        query = `${query}&status=${this.ruleForm.status}`
      }
      if (this.ruleForm.marketplace_id) {
        query = `${query}&marketplace_id=${this.ruleForm.marketplace_id}`
      }
      if (this.ruleForm.agent_id) {
        query = `${query}&agent_id=${this.ruleForm.agent_id}`
      }
      if (this.ruleForm.equipment_model_id) {
        query = `${query}&equipment_model_id=${this.ruleForm.equipment_model_id}`
      }
      this.$emit('filter', query)
    },
  },
  async mounted() {
    if (this.$can('2|4|5')) {
      this.ruleForm.marketplace_id = this.currentUser.marketplace_id
    }
    if (this.$can('4')) {
      this.ruleForm.agent_id = this.currentUser.agent_id
    }
    if (this.$can('5')) {
      this.$set(this.ruleForm, 'department_store_id', this.currentUser.department_store_id)
      this.ruleForm.department_store_id = this.currentUser.department_store_id

      this.$set(this.ruleForm, 'marketplace_id', this.currentUser.department_store.marketplace_id)
      this.ruleForm.marketplace_id = this.currentUser.department_store.marketplace_id

      this.$set(this.ruleForm, 'agent_id', this.currentUser.department_store.agent_id)
      this.ruleForm.agent_id = this.currentUser.department_store.agent_id
    }
  }
}
</script>

<style scoped>

</style>
